import 'src/style/app.scss'

/* React */
import { HashRouter as Router } from 'react-router-dom'
import { Helmet, HelmetProvider } from 'react-helmet-async'

/* Context */
import { useContext } from 'react'
import { AppContext } from 'src/AppContext'

/* Components */
import AutoLogin from './AutoLogin'
import Header from './Header/Header'
import Footer from './Footer/Footer'
import Routes from 'src/routes/Routes'

/* Spezial Routes */
import Login from 'src/routes/Login/Login'

const App:React.FC = () => {
  const { appState:{user} } = useContext(AppContext)

  if (!user) return <HelmetProvider>
    <div className="App">

      <Helmet>
        <title>HL| Login</title>
      </Helmet>

      <Login />

    </div>
  </HelmetProvider>

  return <HelmetProvider>

    <Helmet>
      <title>HL| Shops</title>
    </Helmet>

    <AutoLogin />  
    <Router basename="/">
      <div className="App">
        
        <Header />

        <Routes />
        
        <Footer />
        
      </div>
    </Router>

  </HelmetProvider>

}

export default App